import React from "react";
import Pagination from "components/base/Pagination";
import { Button, ButtonToolbar, Checkbox, Notification } from "rsuite";
import RenderedColumns from "./RenderColumns";
import { ObjectSet, isFunction, compareTwoArrays, resolvePerPage } from "utils";
import ShowColumnPicker from "components/Table/ShowColumnPicker";
import BaseTable, { Column, HeaderCell, Cell } from "components/base/BaseTable";
import { DEFAULT_PER_PAGE_MEDIUM } from "const";
import { injectIntl } from "react-intl";

import m from "definedMessages";

/**
 * Для правильной работы выбора колонок в таблицу нужно передать columnSelectorLSKey
 * это и будет являться ключём для храрения выбраных колонок в LocalStorage
 */
export class MyTable extends React.Component {

    getOriginalColumns = (props = this.props) => {
        if (Array.isArray(props.originalColumns)) {
            return props.originalColumns;
        }

        return Array.isArray(props.columns) ? props.columns : [];
    };

    isColumnSelectorPersistenceEnabled = (props = this.props) => {
        return Boolean(props.columnSelectorLSKey && !props.noSelector);
    };

    getDefaultPerPage = (props) => {
        return props.perPage ?? props.per_page ?? DEFAULT_PER_PAGE_MEDIUM;
    };

    getPropPerPage = (props) => {
        return props.perPage ?? props.per_page;
    };

    getResolvedPerPage = (props = this.props) => {
        return props.perPageLSKey
            ? this.state?.perPage ?? this.getInitialPerPage(props)
            : this.getDefaultPerPage(props);
    };

    getInitialPerPage = (props) => {
        return resolvePerPage(
            props.perPageLSKey,
            this.getPropPerPage(props),
            this.getDefaultPerPage(props)
        );
    };

    getPickableColumnKeys = (columns) => columns
        .filter(column => column.pickable !== false)
        .map(column => column.dataKey);

    getDefaultColumnKeys = (columns) => columns
        .filter(column => column.pickable !== false && !column.hideDefault)
        .map(column => column.dataKey);

    getHiddenColumnsStorageKey = (props = this.props) => (
        `${props.columnSelectorLSKey}__HIDDEN_COLUMNS`
    );

    haveColumnsChanged = (columns, prevColumns) => (
        columns.length !== prevColumns.length
        || columns.some((column, index) => column !== prevColumns[index])
    );

    normalizeColumnKeys = (keys, allColumnsKeys) => {
        if (!Array.isArray(keys)) {
            return allColumnsKeys;
        }

        const filteredKeys = keys.filter(key => allColumnsKeys.includes(key));

        if (keys.length && !filteredKeys.length) {
            return allColumnsKeys;
        }

        return filteredKeys;
    };

    getInitialColumnKeys = (props = this.props) => {
        const originalColumns = this.getOriginalColumns(props);
        const allColumnsKeys = this.getPickableColumnKeys(originalColumns);
        const defaultColumnKeys = this.getDefaultColumnKeys(originalColumns);

        if (!this.isColumnSelectorPersistenceEnabled(props)) {
            return defaultColumnKeys;
        }

        let visibleKeys = defaultColumnKeys;
        const savedKeys = localStorage.getItem(props.columnSelectorLSKey);

        if (savedKeys !== null) {
            try {
                visibleKeys = this.normalizeColumnKeys(JSON.parse(savedKeys), allColumnsKeys);
            } catch (error) {
                visibleKeys = defaultColumnKeys;
            }
        }

        let hiddenKeys = [];
        const savedHiddenKeys = localStorage.getItem(this.getHiddenColumnsStorageKey(props));

        if (savedHiddenKeys !== null) {
            try {
                const parsedHiddenKeys = JSON.parse(savedHiddenKeys);
                hiddenKeys = Array.isArray(parsedHiddenKeys)
                    ? parsedHiddenKeys.filter(key => allColumnsKeys.includes(key))
                    : [];
            } catch (error) {
                hiddenKeys = [];
            }
        }

        const newColumnKeys = defaultColumnKeys.filter(key => (
            !visibleKeys.includes(key) && !hiddenKeys.includes(key)
        ));

        return Array.from(new Set([...visibleKeys, ...newColumnKeys]));
    };

    syncColumnSelectorStorage = (visibleKeys, props = this.props) => {
        if (!this.isColumnSelectorPersistenceEnabled(props)) {
            return;
        }

        const allColumnKeys = this.getPickableColumnKeys(this.getOriginalColumns(props));
        const hiddenKeys = allColumnKeys.filter(key => !visibleKeys.includes(key));

        localStorage.setItem(props.columnSelectorLSKey, JSON.stringify(visibleKeys));
        localStorage.setItem(
            this.getHiddenColumnsStorageKey(props),
            JSON.stringify(hiddenKeys)
        );
        localStorage.removeItem(`${props.columnSelectorLSKey}__KNOWN_COLUMNS`);
        localStorage.removeItem(`${props.columnSelectorLSKey}__STATE_V2`);
    };

    constructor(props) {
        super(props);

        this.selectedlist = this.props.isSetObject
            ? new ObjectSet()
            : new Set();

        const columnsKeys = this.getInitialColumnKeys(props);

        this.formatMessage = props.intl.formatMessage.bind(props.intl);

        this.state = {
            selectAll: false,
            columns: [],
            isSelectColumnsDropdownOpen: false,
            showColumnsKeys: columnsKeys,
            perPage: this.getInitialPerPage(props),
        };
    }

    // configureColumns () {
    //     const { columnSelectorLSKey, isChangedColumns } = this.props;

    //     // implement isChangedColumns to this logic

    //     let columns = [...this.props.columns];
    //     const showColumnsKeys = this.state.showColumnsKeys;


    //     let columnsKeys = columns
    //         .filter(column => !column.hideDefault)
    //         .map(column => column.dataKey);

    //     let currentColumnsKeys = showColumnsKeys;

    //     if (!compareTwoArrays(showColumnsKeys, columnsKeys)) {
    //         currentColumnsKeys = columnsKeys;
    //     }

    //     if (columnSelectorLSKey) {
    //         //Set saved
    //         localStorage.setItem(columnSelectorLSKey, JSON.stringify(showColumnsKeys));

    //         columns = columns.filter((column) => showColumnsKeys.includes(column.dataKey));

    //         if (columns.length) {
    //             columns[0].headerProps = {className:`rs-table-cell-header-with-icon`};
    //         }
    //     }

    //     this.setState({
    //         columns,
    //         // showColumnsKeys: currentColumnsKeys
    //     });

    // }

    configureColumns() {
        let columns = [...this.props.originalColumns];
        const showColumnsKeys = this.state.showColumnsKeys;
        const { columnSelectorLSKey } = this.props;
        const isColumnSelectorPersistenceEnabled = this.isColumnSelectorPersistenceEnabled();

        if (isColumnSelectorPersistenceEnabled) {
            //Set saved
            localStorage.setItem(columnSelectorLSKey, JSON.stringify(showColumnsKeys));
            this.syncColumnSelectorStorage(showColumnsKeys);

            columns = this.filterColumns(showColumnsKeys);

            if (columns.length) {
                columns[0].headerProps = { className: `rs-table-cell-header-with-icon` };
            }
        }

        this.setState({ columns });
    }

    filterColumns = (columnKeys, update = false) => {
        const { originalColumns } = this.props;

        const columns = originalColumns.filter(column => (
            column.pickable === false || columnKeys.includes(column.dataKey)
        ));

        if (update) {
            this.setState({ columns });
        }

        return columns;
    };

    clear = () => {
        const { isselected } = this.props;
        const { selectAll } = this.state;

        if (isselected) {
            this.selectedlist.clear();

            if (selectAll) {
                this.setState({ selectAll: false }, this.setSelectParent)
            } else {
                this.setSelectParent()
            }
        }
    };

    shouldComponentUpdate({ data, stateChecked }) {
        if (stateChecked && data !== this.props.data) {
            data.map(row => {
                return (row.checked) && (this.selectedlist.add(this.gettingSelectItem(row)))
            })
        }
        return true;
    }

    componentDidMount() {
        this.configureColumns();
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     //Uncheck checkboxes when data in table changes
    //     if (this.props.service !== prevProps.service && this.props.isChangedColumns) {
    //         const columns = this.props.columns
    //             .filter(column => !column.hideDefault)
    //             .map(column => column.dataKey);

    //         this.setState({showColumnsKeys: columns});
    //     }

    //     if (this.props.count && prevProps.count !== this.props.count) {
    //         this.onToggleAll(false);
    //     }

    //     if (this.state.showColumnsKeys !== prevState.showColumnsKeys && this.props.isChangedColumns) {
    //         this.configureColumns();
    //     }

    // }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const isColumnSelectorPersistenceEnabled = this.isColumnSelectorPersistenceEnabled();
        const wasColumnSelectorPersistenceEnabled = this.isColumnSelectorPersistenceEnabled(prevProps);

        if (this.props.perPageLSKey !== prevProps.perPageLSKey) {
            const perPage = this.getInitialPerPage(this.props);

            if (perPage !== this.state.perPage) {
                this.setState({ perPage });
            }
        }

        //Uncheck checkboxes when data in table changes
        if (this.props.count && prevProps.count !== this.props.count) {
            this.onToggleAll(false);
        }

        if (
            this.props.columnSelectorLSKey !== prevProps.columnSelectorLSKey
            || isColumnSelectorPersistenceEnabled !== wasColumnSelectorPersistenceEnabled
        ) {
            const nextKeys = this.getInitialColumnKeys(this.props);
            this.syncColumnSelectorStorage(nextKeys);
            this.setState({ showColumnsKeys: nextKeys });
            this.filterColumns(nextKeys, true);
            return;
        }

        // if (this.props.columns !== prevProps.columns
        //     || this.state.showColumnsKeys !== prevState.showColumnsKeys) {
        //     this.configureColumns();
        // }

        const allColumnsKeys = this.getPickableColumnKeys(this.props.originalColumns);

        if (this.props.additionalColumnUpdate !== prevProps.additionalColumnUpdate) {
            const nextKeys = this.getPickableColumnKeys(this.props.originalColumns);

            if (isColumnSelectorPersistenceEnabled) {
                localStorage.setItem(
                    this.props.columnSelectorLSKey,
                    JSON.stringify(nextKeys)
                );
                this.syncColumnSelectorStorage(nextKeys);
            }

            this.setState({
                showColumnsKeys: nextKeys,
                columns: this.filterColumns(nextKeys),
            });

            return;
        }

        if (this.props.service !== prevProps.service) {
            if (isColumnSelectorPersistenceEnabled) {
                localStorage.removeItem(this.props.columnSelectorLSKey)
            }
        }

        if (!compareTwoArrays(this.state.showColumnsKeys, prevState.showColumnsKeys)) {
            if (isColumnSelectorPersistenceEnabled) {
                localStorage.setItem(this.props.columnSelectorLSKey, JSON.stringify(this.state.showColumnsKeys));
                this.syncColumnSelectorStorage(this.state.showColumnsKeys);
            }
            this.filterColumns(this.state.showColumnsKeys, true);
            return;
        }

        if (
            !compareTwoArrays(allColumnsKeys, this.state.showColumnsKeys)
            && !(isColumnSelectorPersistenceEnabled && localStorage.getItem(this.props.columnSelectorLSKey))
        ) {
            this.setState({
                showColumnsKeys: allColumnsKeys
            });
            this.filterColumns(allColumnsKeys, true);
            // localStorage.removeItem(this.props.columnSelectorLSKey)
        }

        if (this.props.extraColumnUpdate !== undefined && this.props.extraColumnUpdate !== prevProps.extraColumnUpdate) {
            this.filterColumns(this.state.showColumnsKeys, true);
        }

        if (!compareTwoArrays(this.props.columns, this.state.columns) &&
            compareTwoArrays(this.props.columns, this.props.originalColumns) &&
            !this.props.columnSelectorLSKey
        ) {
            this.setState({
                columns: this.props.columns
            });
        }
        const originalColumns = this.getOriginalColumns();
        const prevOriginalColumns = this.getOriginalColumns(prevProps);
        const prevAllColumnsKeys = this.getPickableColumnKeys(prevOriginalColumns);
        if (!compareTwoArrays(allColumnsKeys, prevAllColumnsKeys)) {
            const nextKeys = this.getInitialColumnKeys(this.props);
            this.syncColumnSelectorStorage(nextKeys);
            this.setState({ showColumnsKeys: nextKeys });
            this.filterColumns(nextKeys, true);
        } else if (this.haveColumnsChanged(originalColumns, prevOriginalColumns)) {
            this.filterColumns(this.state.showColumnsKeys, true);
        }

        if (this.props.clearSelected) {
            this.clear();
        }
    }

    onChangePage = (page) => {
        const { customChangePage = false } = this.props;
        const perPage = this.getResolvedPerPage();

        if (!customChangePage) {
            this.props.getItems(page, perPage);
        }

        if (this.props.onChangePage)
            this.props.onChangePage(page);
    };

    onChangePerPage = (value) => {
        const { customChangePerPage = false } = this.props;

        if (this.props.perPageLSKey) {
            localStorage.setItem(this.props.perPageLSKey, value);
            this.setState({ perPage: value });
        }

        if (!customChangePerPage) {
            this.props.getItems(1, value);
        }

        if (this.props.onChangePerPage)
            this.props.onChangePerPage(value);
    };

    setSelectParent = () => {
        const { setSelected } = this.props;
        const { selectAll } = this.state;

        if (!setSelected) return;

        setSelected({
            list: Array.from(this.selectedlist.values()),
            all: selectAll
        })
    };

    onToggle = (id, checked) => {
        const { useSelectedData, data = [], row_key = "id", onCheckPrevented } = this.props;

        if (checked) {
            this.selectedlist.add(id);
        } else {
            this.selectedlist.delete(id);
        }

        if (useSelectedData) {
            const checkedData = data.filter(item => item[row_key] === id);
            useSelectedData(checkedData, checked)
        }

        if (checked && onCheckPrevented) {
            const checkedItem = data.find(item => item.id === id);
            if (checkedItem.preventCheck)
                onCheckPrevented();
        }

        this.setSelectParent();
        this.forceUpdate();
    };

    onToggleAll = (checked) => {
        const { selectAll } = this.state;
        const { data, ispagination, isSelectedAll, useSelectedData } = this.props;

        if (!checked) {
            speaker(Notification.close("allocatedNumberChooser"), null, this.formatMessage);
        }

        if (isSelectedAll && checked && !selectAll && ispagination) {
            Notification.open({
                duration: 0,
                description: [
                    <div className="mb-2">{this.formatMessage(m.doYouWantToChooseRecordsOnAllPages)}</div>,
                    <div className="text-right">{
                        speaker(
                            () => {
                                this.selectedlist.clear();
                                this.setState({ selectAll: true }, this.setSelectParent);
                                Notification.closeAll();
                            },
                            () => {
                                Notification.closeAll();
                            },
                            this.formatMessage
                        )
                    }</div>
                ],
                key: "allocatedNumberChooser"
            });
        } else if (!checked && selectAll) {
            this.setState({ selectAll: false }, this.setSelectParent);
        }

        for (let row of data) {
            (checked && !row.preventCheck)
                ? this.selectedlist.add(this.gettingSelectItem(row))
                : this.selectedlist.delete(this.gettingSelectItem(row))
        }

        if (useSelectedData) {
            useSelectedData(data, checked)
        }

        this.setSelectParent();
        this.forceUpdate();
    };

    getHeight = () => {
        const { data = [], height, customHeight, rowHeight } = this.props;
        const heightValues = ((data.length * (rowHeight || 30)) || 100) + 50;

        switch (height) {
            case "75%":
                const h75 = (window.innerHeight / 1.33);
                return Math.min(h75, heightValues);
            case "50%":
                const h50 = (window.innerHeight / 2);
                return Math.min(h50, heightValues);
            case "30%":
                const h30 = (window.innerHeight / 3);
                return Math.min(h30, heightValues);
            case "25%":
                const h25 = (window.innerHeight / 4);
                return Math.min(h25, heightValues);
            default:
                return customHeight ? customHeight : heightValues;
        }
    };

    gettingSelectItem = (row) => {
        const { isSetObject, row_key = "id" } = this.props;
        return isSetObject ? row : row[row_key];
    };

    render() {
        const {
            data = [], loading, isselected, row_key = "id", active_id,
            ispagination, count, page, perPage, onRowClick, customRowClick, isMobile, perPageMaximum, showFirstAndLast,
            width, ActionCell, hidePages = false, hidePerPage = false, showedCount, disabled, columns, getItems, height, extraHeight,
            hideTotalCount, resizable = false, ...props
        } = this.props;

        const resolvedPerPage = this.getResolvedPerPage();

        const { selectAll } = this.state;
        const _renderedColumns = RenderedColumns(this.state.columns, null, isMobile, resizable);

        const _columns = _renderedColumns;

        const propTables = { ...props };

        if (onRowClick)
            propTables.onRowClick = (row) => {
                if (customRowClick) {
                    return onRowClick(row);
                }

                return onRowClick(row[row_key]);
            }
        if (active_id) {
            propTables.rowClassName = (row) => {
                let rowClass = row && row[row_key] === active_id ? "row-active" : null;
                if (!rowClass && props.rowClassName) {
                    rowClass = isFunction(props.rowClassName)
                        ? props.rowClassName(row)
                        : props.rowClassName;
                }
                return rowClass;
            }
        }

        if (width)
            propTables.width = width;

        if (!ispagination)
            propTables.virtualized = true;

        return (
            <div className="position-relative">
                {this.props.columnSelectorLSKey && !this.props.noSelector &&
                    <ShowColumnPicker
                        value={this.state.showColumnsKeys}
                        columns={this.props.originalColumns}
                        onChange={(value) => {
                            if (!!this.props.onPickColumns) {
                                this.props.onPickColumns(value);
                            }
                            this.setState({ showColumnsKeys: value });
                        }}
                        loading={loading}
                    />
                }
                <BaseTable
                    height={extraHeight ? extraHeight : this.getHeight()}
                    data={data}
                    loading={loading}
                    rowHeight={30}
                    columnSelector={!!this.props.columnSelectorLSKey}
                    {...propTables}

                >
                    {_columns}
                    {ActionCell}

                    {isselected &&
                        <Column width={50}>
                            <HeaderCell>
                                {data.length
                                    ? <Checkbox
                                        onChange={(v, checked) => this.onToggleAll(checked)}
                                        checked={selectAll || data.every(
                                            row => this.selectedlist.has(this.gettingSelectItem(row))
                                        )}
                                        style={{ position: "relative", top: "-5px" }}
                                    />
                                    : ""
                                }
                            </HeaderCell>
                            <Cell>
                                {(row) => (
                                    <Checkbox
                                        disabled={selectAll || row.disabled}
                                        checked={row.checked || this.selectedlist.has(this.gettingSelectItem(row)) || selectAll}

                                        onChange={(v, checked) => this.onToggle(this.gettingSelectItem(row), checked)}
                                        style={{ position: "relative", top: "-5px" }}
                                    />
                                )}
                            </Cell>
                        </Column>
                    }

                    <Column key="table_scrollfix" width={0} fixed>
                        <HeaderCell></HeaderCell>
                        <Cell></Cell>
                    </Column>
                </BaseTable>

                {ispagination &&
                    <Pagination
                        disabled={disabled}
                        total={count}
                        perPage={resolvedPerPage}
                        activePage={page}
                        hidePages={hidePages}
                        hidePerPage={hidePerPage}
                        showedCount={showedCount}
                        perPageMaximum={perPageMaximum}
                        showFirstAndLast={showFirstAndLast}
                        onChangePage={this.onChangePage}
                        onChangePerPage={this.onChangePerPage}
                    />
                }

            </div>
        );

    }
}


export default injectIntl(MyTable, { forwardRef: true });

const speaker = (Ok, No, formatMessage) => (
    <div>
        <ButtonToolbar>
            <Button onClick={Ok}>{formatMessage(m.yes)}</Button>
            <Button onClick={No} >{formatMessage(m.onlyOnThisPage)}</Button>
        </ButtonToolbar>
    </div>
);
